import {
  Badge,
  InputErrorMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

const monthNames = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

interface FiscalMonthSelectMenuProps extends UseFormRegisterReturn {
  defaultValue?: string;
  error?: string;
}

const FiscalMonthSelectMenu = React.forwardRef<
  HTMLButtonElement,
  FiscalMonthSelectMenuProps
>(({ name, onChange, required, disabled, defaultValue, error }, ref) => {
  const monthNumberArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div className="flex flex-col gap-2">
      <Select
        name={name}
        onValueChange={(value) => onChange({ target: { name, value } })}
        required={required}
        disabled={disabled}
        {...(defaultValue ? { defaultValue } : {})}
      >
        <SelectTrigger ref={ref} className="w-full">
          <SelectValue />
        </SelectTrigger>

        <SelectContent>
          {monthNumberArray.map((monthNumber) => (
            <SelectItem
              value={monthNumber.toString()}
              key={monthNumber}
              className="w-full flex items-center justify-between gap-2"
            >
              <div
                className="flex justify-between items-center gap-2"
                style={{ width: '456px' }}
              >
                <div className="text-left">{monthNames[monthNumber]}</div>
                {monthNumber === 1 ? (
                  <Badge variant="blue" className="mr-2">
                    Suggested
                  </Badge>
                ) : null}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error ? <InputErrorMessage message={error} /> : null}
    </div>
  );
});

FiscalMonthSelectMenu.displayName = 'FiscalMonthSelectMenu';

export default FiscalMonthSelectMenu;
